<template>
  <div class="wim-footer">
    <div class="wim-footer-container tva-row">
      <div class="wim-foter-left tva-col-sm-offset-1 tva-col-sm-3">
        <div class="wim-footer-title">{{content.title}}</div>
        <p class="white name" v-html="content.firstLine">{{content.firstLine}}</p>
        <p class="white name" v-html="content.secondLine">{{content.secondLine}}</p>
        <div class="wim-footer-subtitle">{{content.secondTitle}}</div>
        <a href="https://thevisualagency.com/" target="_blank"><img :src="baseUrl + 'images/'+content.logo+'.svg'" alt="The Visual Agency"></a>
      </div>
      <div class="wim-footer-right tva-col-sm-offset-1 tva-col-sm-6">
        <p class="white" v-html="content.text">{{content.text}}</p>
        <p class="white" v-html="content.credits">{{content.credits}}</p>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ["content"],
    data() {
      return {
        baseUrl: process.env.BASE_URL
      };
    }
  }
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
  .wim-footer {
    width: 100vw;
    padding: 50px 0;
    margin-top: 120px;
    background:$black;
    .wim-footer-container {
      max-width: 1360px;
      margin: 0 auto;
      display: flex;
      align-items: flex-start;
      .wim-footer-title {
        font-family : 'Nunito Sans', sans-serif;
        font-weight : bold;
        font-size : 16px;
        line-height : 22px;
        letter-spacing : 0.4px;
        color: $red;
        text-transform: uppercase;
        margin-bottom:10px;
      }
      .wim-footer-subtitle {
        font-family : 'Nunito Sans', sans-serif;
        font-weight : bold;
        font-size : 16px;
        line-height : 22px;
        letter-spacing : 0.4px;
        color: $red;
        margin-top:5%;
        margin-bottom:10px;
      }
      p {
        font-size : 15px;
        line-height : 22px;
      }
      .name {
        margin: 0;
      }
      .subtitle {
        font-size: 16px;
        font-weight: 800;
        text-transform: capitalize;
        letter-spacing : 0.4px;
      }
      img {
        background: none;
      }
      .white:first-of-type {
        margin-top: 0;
      }
    }
  }
  @media(max-width:768px) {
    .wim-footer {
      .wim-footer-container {
        flex-direction: column;
        text-align: center;
        justify-content: center;
        align-items: center;
        .wim-footer-right {
          width: 80%;
          margin-top: 40px;
          padding:0;
        }
        .wim-footer-left {
          padding:0;
        }
        .wim-footer-subtitle {
          margin-top: 20px;
        }
      }
    }
  }
  
</style>